import { useLayoutEffect } from 'react';

import css from './styles.css';

const ZOOM_ASPECT_RATIO = 1.3; // критичная точка aspectRatio после которой происходи изменение значения свойства object-fit с contain на cover

/**
 * Определяет текущие размеры видео и в зависимости от этого устанавливает нужную ориентацию видео
 */
const applyVideoOrientationStyles = (videoElement: HTMLVideoElement) => {
    const height = videoElement.videoHeight;
    const width = videoElement.videoWidth;

    const isVertical = height && width && width / height <= ZOOM_ASPECT_RATIO;
    const isVerticallyAligned = videoElement.classList.contains(css.videoContainMode);

    if (isVertical && !isVerticallyAligned) {
        videoElement.classList.add(css.videoContainMode);
    } else if (!isVertical && isVerticallyAligned) {
        videoElement.classList.remove(css.videoContainMode);
    }
};

/**
 * Контролирует положение видео в контейнере в зависимости от ориентации
 */
export const useVideoOrientation = (videoElement?: HTMLVideoElement | null) => {
    useLayoutEffect(() => {
        if (videoElement) {
            applyVideoOrientationStyles(videoElement);

            const onVideoResize = () => applyVideoOrientationStyles(videoElement);
            videoElement.addEventListener('resize', onVideoResize);

            return () => videoElement.addEventListener('resize', onVideoResize);
        }
    }, [videoElement]);
};
